import { useEffect, useRef, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import Html from "./html";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

const SubAdmin = () => {
  const history = useNavigate()
  const user = useSelector((state) => state.user)
  const searchState = { data: "" }
  const [filters, setFilter] = useState({ page: 1, count: 10, search: "" })
  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)
  const roleId = useRef()

  useEffect(() => {
    getSubAdminRoleId()
  }, [])

  const getData = (p = {}) => {
    let filter = { ...filters, ...p, role: roleId.current }
    ApiClient.get("user/listing", filter).then((res) => {
      if (res.success) {
        setData(res?.data)
        setTotal(res.total)
      }
      loader(false)
    })
  }

  const getSubAdminRoleId = () => {
    loader(true)
    ApiClient.get(`role/listing`).then(res => {
      if (res.success) {
        roleId.current = res?.data?.find(itm => itm?.name == "sub admin")?.id
        getData({ search: searchState.data })
      } else {
        loader(false)
      }
    })
  }

  const clear = () => {
    let f = {
      groupId: "",
      search: "",
      status: "",
    };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  }

  const filter = (p = {}) => {
    let f = {
      ...p,
    };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  }

  const deleteSubAdmin = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete this Sub Admin`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        loader(true);
        ApiClient.delete(`user/delete?id=${id}`).then((res) => {
          if (res.success) {
            clear();
          }
          loader(false);
        });
      }
    });
  }

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  }
  const count = (e) => {
    setFilter({ ...filters, count: e });
    getData({ ...filters, count: e });
  }
  const changestatus = (e) => {
    setFilter({ ...filters, status: e });
    getData({ status: e });
  }

  const statusChange = (itm) => {
    let status = "active"
    if (itm?.status == "active") status = "deactive"
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status == "active" ? "Activate" : "Deactivate"
        } this user?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        loader(true)
        ApiClient.put("user/status/change", { id: itm?._id || itm?.id, status }).then((res) => {
          if (res.success) {
            getData()
          }
          loader(false)
        })
      }
    })
  }

  const edit = (id) => {
    history(`/subadmin/edit/${id}`);
  }

  const view = (id) => {
    let url = `/subadmin/detail/${id}`;
    history(url);
  }

  const handleSearch = (e) => {
    setFilter({ ...filters, search: e.target.value });
    if (e.target.value === "") {
      getData({ search: "" })
    }
  }

  const isAllow = (key = "") => {
    if (user?.role?.name == "admin") return true
    let permissions = user?.role?.permissions?.[0]
    let value = permissions?.[key]
    return value;
  };

  return (
    <>
      <Html
        edit={edit}
        view={view}
        clear={clear}
        count={count}
        pageChange={pageChange}
        deleteSubAdmin={deleteSubAdmin}
        filters={filters}
        setFilter={setFilter}
        filter={filter}
        data={data}
        total={total}
        statusChange={statusChange}
        changestatus={changestatus}
        handleSearch={handleSearch}
        isAllow={isAllow}
      />
    </>
  );
};

export default SubAdmin;
